import { ParallaxFooter } from '../ParallaxFooter/ParallaxFooter';
import { AtellioMarketingBanner } from './AtellioMarketingBanner';
import { useIsGuest } from 'v4/entities/common/hooks/useIsGuest';

/**
 * ParallaxBanner is a fixed footer that slides up from the bottom as you scroll.
 * The banner is hidden until you reach 50% scroll progress,
 * then smoothly slides up to fully visible at 100% scroll.
 *
 * If there's no scrollable content, banner waits for first user interaction,
 * then fades in after 1 second.
 *
 * Usage: Add at the end of your page/container:
 * <ParallaxBanner />
 */
export function ParallaxBanner() {
  const isGuest = useIsGuest();

  if (!isGuest) {
    return null;
  }

  return (
    <ParallaxFooter>
      <AtellioMarketingBanner />
    </ParallaxFooter>
  );
}
